import { createSelector } from "reselect";

export const selectModule = (state) => state.reportQueryReducer;

/**
 * UI cargado status
 */
export const selectCargando = createSelector(selectModule, (module) => module.ui.cargando);
